import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { useTranslation } from "react-i18next";

import { useFormikContext } from "formik";
import { makeStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Box from "@material-ui/core/Box";
import List from "@material-ui/core/List";

import Modal from "@Components/Modal";
import { ListItem, ListItemText, Typography, Paper } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  label: {
    marginBottom: theme.spacing(1),
    color: "#000",
  },
  error: {
    color: "red",
  },
  nameSpan: {
    fontWeight: "bold",
    color: theme.palette.primary.main,
    "&:hover": {
      cursor: "pointer",
    },
  },
}));

const TabPanel = (props) => {
  const { children, value, index, ...other } = props;
  const { t } = useTranslation();

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
};
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

const a11yProps = (index) => {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
};

const MyTabs = (props) => {
  const { valueForTabs } = props;
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const tabNames = Object.keys(valueForTabs);

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
          variant="scrollable"
          scrollButtons="auto"
        >
          {tabNames.map((tabName, index) => {
            return <Tab key={tabName} label={tabName} {...a11yProps(index)} />;
          })}
        </Tabs>
      </Box>
      {tabNames.map((tabName, index) => {
        return (
          <TabPanel key={index} index={index} value={value}>
            <Paper style={{ maxHeight: 300, overflow: "auto" }}>
              <List>
                {valueForTabs[tabName].map((renderValue) => {
                  return (
                    <ListItem key={renderValue}>
                      <ListItemText primary={renderValue} />
                    </ListItem>
                  );
                })}
              </List>
            </Paper>
          </TabPanel>
        );
      })}
    </Box>
  );
};
MyTabs.propTypes = {
  valueForTabs: PropTypes.object,
};

const TabbedDisplay = (props) => {
  const {
    label,
    required,
    labelClasses,
    errorMessage,
    valueForTabsKey,
  } = props;
  const { t } = useTranslation();
  const classesInner = useStyles();
  const formik = useFormikContext();
  const [valueForTabs, setValuesForTabs] = useState({});

  useEffect(() => {
    const tabValues = formik.values[valueForTabsKey];
    setValuesForTabs(tabValues);
  }, [formik.values]);

  const [modalFields, setModalFields] = useState({
    title: label,
    isOpen: false,
    body: null,
    resetModalBodyState: () =>
      setModalFields({ ...modalFields, isOpen: false }),
    bodyMessage: null,
  });

  const handleShowClick = () => {
    setModalFields({
      ...modalFields,
      body: <MyTabs valueForTabs={valueForTabs} />,
      isOpen: true,
    });
  };

  return (
    <>
      <InputLabel
        htmlFor={name}
        className={clsx(classesInner.label, {
          [classesInner.error]: errorMessage,
          [labelClasses]: labelClasses,
        })}
      >
        {t(label)}
        {required ? <span style={{ color: "red" }}> *</span> : null}
      </InputLabel>

      <span className={classesInner.nameSpan} onClick={handleShowClick}>
      {t("Show")} {label}
      </span>

      <Modal modalFields={modalFields} setModalFields={setModalFields} />
    </>
  );
};

TabbedDisplay.propTypes = {
  label: PropTypes.string,
  required: PropTypes.bool,
  labelClasses: PropTypes.string,
  errorMessage: PropTypes.array,
  valueForTabsKey: PropTypes.string,
};

export default TabbedDisplay;
